import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CloseIcon from "../assets/img/close-white.svg";

interface ModalProps {
    openModal: boolean;
    toggleModal: () => void;
    title?: string;
    children?: any;
    footer?: any;
}
const ModalComponent = ({
    openModal,
    toggleModal,
    title,
    children,
    footer
}: ModalProps) => {

    const closeIcon = (
        <img src={CloseIcon} style={{ cursor: 'pointer' }} onClick={toggleModal}></img>
    );
    return (
        <>
            <Modal
                isOpen={openModal}
                toggle={toggleModal}
                centered
                backdrop={'static'}
                size='lg'
            >
                {title && <ModalHeader toggle={toggleModal}>{title}</ModalHeader>}
                <ModalBody>{children}</ModalBody>
                {footer && <ModalFooter>{footer}</ModalFooter>}
            </Modal>

        </>
    );
}


export default ModalComponent;